import { FC, useMemo, useState } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import { houseToHouseServices } from '@/services';
import { Loading } from '../Loading';
import { typeHTHFace } from '@monorepo/models';
import { useGetConfig } from '@/custom-hooks';

type propsType = {
    setValues: (face: typeHTHFace | null, streetNumber: number) => void;
    values: { face: typeHTHFace | null; streetNumber: number; };
};

export const HTHLocateFaceFromAddress: FC<propsType> = ({ setValues, values }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [address, setAddress] = useState('');
    const [showNotFound, setShowNotFound] = useState(false);
    const { face } = values;
    const config = useGetConfig();

    const isValid: boolean = useMemo(() =>
        address.trim().length > 6
        && !!address.trim().replace(/[^0-9]/g, '').length  // at least 1 number
        && address.trim().includes(' ')
    , [address]);

    const sendAddress = async () => {
        if (!isValid || isLoading) {
            return;
        }
        setIsLoading(true);
        const response = await houseToHouseServices.GetFaceFromAddress(`${address.trim()}, ${config.congregationArea ?? 'Argentina'}`);
        setIsLoading(false);
        if (response?.success && response.data?.hthFace?.block && response.data.hthFace?.face && response.data.hthFace?.territoryNumber && response.data.hthFace.street) {
            setValues(response.data.hthFace, response.data.streetNumber ?? 0);
        } else {
            setShowNotFound(true);
            setValues(null, 0);
        }
    }

    return (
        <>
        <FloatingLabel
            className={'text-dark mb-3'}
            label={'Dirección'}
        >
            <Form.Control
                type={'text'}
                className={'form-control'}
                placeholder={''}
                value={address}
                onChange={e => {
                    setShowNotFound(false);
                    setAddress(e.target.value);
                    setValues(null, 0);
                }}
                onKeyDown={e => e.key === 'Enter' ? sendAddress() : null}
                autoFocus
            />
        </FloatingLabel>
        {isLoading ?
            <Loading white={false} mt='40px' mb='20px' />
            :
            <button className='btn btn-general-blue w-100'
                onClick={sendAddress}
                disabled={!isValid || showNotFound || !!face}
            >
                Aceptar
            </button>
        }
        {showNotFound &&
            <h5 className={'bg-danger text-white text-center py-3 mt-4'}>
                No se encontró
            </h5>
        }
        </>
    );
}
